module.exports = {
	// steps
	SITE_TITLE_STEP_SLUG: 'title',
	IS_BLOG_STEP_SLUG: 'is-blog',
	HOMEPAGE_STEP_SLUG: 'homepage',
	TRAFFIC_STEP_SLUG: 'traffic',
	STATS_MONITORING_STEP_SLUG: 'stats-monitoring',
	DESIGN_STEP_SLUG: 'design',
	ADVANCED_STEP_SLUG: 'advanced',
	REVIEW_STEP_SLUG: 'review',
	JETPACK_MODULES_STEP_SLUG: 'jetpack',
	CONTACT_PAGE_STEP_SLUG: 'contact-page',
	BUSINESS_ADDRESS_SLUG: 'business-address',
	WOOCOMMERCE_SLUG: 'woocommerce'
};



// WEBPACK FOOTER //
// ./client/constants/jetpack-onboarding-paths.js